module.exports = __webpack_public_path__ + "img/logo-full.00eb567d.svg";